/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopUpBillingWalletResponseData } from './TopUpBillingWalletResponseData';
import {
    TopUpBillingWalletResponseDataFromJSON,
    TopUpBillingWalletResponseDataFromJSONTyped,
    TopUpBillingWalletResponseDataToJSON,
    TopUpBillingWalletResponseDataToJSONTyped,
} from './TopUpBillingWalletResponseData';

/**
 * 
 * @export
 * @interface TopUpBillingWalletResponse
 */
export interface TopUpBillingWalletResponse {
    /**
     * 
     * @type {TopUpBillingWalletResponseData}
     * @memberof TopUpBillingWalletResponse
     */
    data: TopUpBillingWalletResponseData;
}

/**
 * Check if a given object implements the TopUpBillingWalletResponse interface.
 */
export function instanceOfTopUpBillingWalletResponse(value: object): value is TopUpBillingWalletResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function TopUpBillingWalletResponseFromJSON(json: any): TopUpBillingWalletResponse {
    return TopUpBillingWalletResponseFromJSONTyped(json, false);
}

export function TopUpBillingWalletResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopUpBillingWalletResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TopUpBillingWalletResponseDataFromJSON(json['data']),
    };
}

  export function TopUpBillingWalletResponseToJSON(json: any): TopUpBillingWalletResponse {
      return TopUpBillingWalletResponseToJSONTyped(json, false);
  }

  export function TopUpBillingWalletResponseToJSONTyped(value?: TopUpBillingWalletResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TopUpBillingWalletResponseDataToJSON(value['data']),
    };
}

